import React from 'react';
import PropTypes from 'prop-types';
import styles from './Row.scss';

const propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.element]).isRequired,
};

export function Row({ label, value, ...rest }) {
    return (
        <div className={styles.root} {...rest}>
            <div className={styles.label}>{label}</div>
            <div className={styles.value}>{value}</div>
        </div>
    );
}

Row.propTypes = propTypes;
